<template>
  <div v-if="currentOf">
    <div class="mt-4 mb-4">
      <div class="row">
        <div class="col-md-12 col-lg-6">
          <div class="table-rsesponsive" style="background: white">
            <table class="table table-detail">
              <tbody>
                <tr>
                  <td>
                    <i
                      :class="show.ICON_CALENDAR"
                      class="text-custom-primary"
                    ></i>
                    <span class="font-weight-bold"> Date de création</span>
                  </td>
                  <td>
                    {{
                      currentOf.document.created_at | formatDate('DD/MM/YYYY')
                    }}
                  </td>
                </tr>

                <tr>
                  <td>
                    <i
                      :class="show.ICON_INFO_CIRCLE"
                      class="text-custom-primary"
                    ></i>
                    <span class="font-weight-bold"> Libellé</span>
                  </td>
                  <td>{{ currentOf.libelle }}</td>
                </tr>

                <tr>
                  <td>
                    <i
                      :class="show.ICON_INFO_CIRCLE"
                      class="text-custom-primary"
                    ></i>
                    <span class="font-weight-bold"> Priorité</span>
                  </td>
                  <td>
                    <i
                      :style="`color: ${currentOf.priorite.couleur}`"
                      class="fa fa-circle mr-1"
                    ></i>
                    {{ currentOf.priorite.nom }}
                  </td>
                </tr>
                <tr>
                  <td>
                    <i :class="show.ICON_USER" class="text-custom-primary"></i>
                    <span class="font-weight-bold"> Auteur</span>
                  </td>
                  <td class="text-primary">
                    {{
                      currentOf.document.created_by.prenom
                        ? currentOf.document.created_by.prenom +
                          ' ' +
                          currentOf.document.created_by.nom
                        : currentOf.document.created_by.nom
                    }}
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
        <div class="mt-n4 mt-lg-0 col-md-12 col-lg-6">
          <div class="table-rsesponsive" style="background: white">
            <table class="table table-detail">
              <tbody>
                <tr>
                  <td>
                    <i
                      :class="show.ICON_CALENDAR"
                      class="text-custom-primary"
                    ></i>
                    <span class="font-weight-bold"> Date du besoin</span>
                  </td>
                  <td>{{ currentOf.date_besoin }}</td>
                </tr>
                <tr>
                  <td>
                    <i
                      :class="show.ICON_INFO_CIRCLE"
                      class="text-custom-primary"
                    ></i>
                    <span class="font-weight-bold"> Nomenclature</span>
                  </td>
                  <td>
                    {{ currentOf.nomenclature.libelle }}
                  </td>
                </tr>

                <tr>
                  <td>
                    <i
                      :class="show.ICON_INFO_CIRCLE"
                      class="text-custom-primary"
                    ></i>
                    <span class="font-weight-bold"> Quantité à fabriquer</span>
                  </td>
                  <td>
                    {{ currentOf.quantite + ' ' + currentOf.produit.unite }}
                  </td>
                </tr>

                <tr>
                  <td>
                    <i
                      :class="show.ICON_INFO_CIRCLE"
                      class="text-custom-primary"
                    ></i>
                    <span class="font-weight-bold"> Avancement</span>
                  </td>
                  <td>
                    <div class="d-flex justify-content-between">
                      <div>{{ currentOf.avancement }} %</div>
                      <div>|</div>
                      <div>
                        {{ currentOf.total_production }} /
                        {{ currentOf.quantite }}
                      </div>
                    </div>
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
      </div>

      <div class="row mt-n2">
        <div class="col-lg-12">
          <div role="tablist">
            <b-card
              no-body
              class="mb-2"
              v-for="(item, index) in currentOf.item_lists"
              :key="index"
            >
              <b-card-header
                header-tag="header"
                role="tab"
                v-b-toggle="'accordion-' + (index + 1)"
                header-class="bg-silver"
              >
                <span class="when-open">
                  <h6 class="m-0">
                    <a class="text-dark" href="javascript: void(0);">{{
                      item.libelle
                        ? 'Etape ' + (index + 1) + ' : ' + item.libelle
                        : 'Etape ' + (index + 1)
                    }}</a>
                    <span class="accicon">
                      <span class="mr-4">
                        Statut :
                        <i
                          :class="[
                            {
                              'text-warning':
                                item.statut === CONST_ETAPE.ATTENTE,
                              'text-success':
                                item.statut === CONST_ETAPE.ENCOURS ||
                                item.statut === CONST_ETAPE.TERMINER,
                              'text-danger':
                                item.statut === CONST_ETAPE.ARRETER,
                            },
                            show.MDI_CHECKBOX_CIRCLE,
                            'mr-1',
                          ]"
                        ></i>
                        {{ getStatutEtape(item.statut) }}
                      </span>
                      <i :class="show.ICON_ANGLE_UP"></i>
                    </span>
                  </h6>
                </span>
                <span class="when-closed">
                  <h6 class="m-0">
                    <a class="text-dark" href="javascript: void(0);">{{
                      item.libelle
                        ? 'Etape ' + (index + 1) + ' : ' + item.libelle
                        : 'Etape ' + (index + 1)
                    }}</a>
                    <span class="accicon">
                      <span class="mr-4">
                        Statut :
                        <i
                          :class="[
                            {
                              'text-warning':
                                item.statut === CONST_ETAPE.ATTENTE,
                              'text-success':
                                item.statut === CONST_ETAPE.ENCOURS ||
                                item.statut === CONST_ETAPE.TERMINER,
                              'text-danger':
                                item.statut === CONST_ETAPE.ARRETER,
                            },
                            show.MDI_CHECKBOX_CIRCLE,
                            'mr-1',
                          ]"
                        ></i>
                        {{ getStatutEtape(item.statut) }}
                      </span>
                      <i :class="show.ICON_ANGLE_UP"></i>
                    </span>
                  </h6>
                </span>
              </b-card-header>
              <b-collapse
                style="background-color: #f3f3f3"
                :id="'accordion-' + (index + 1)"
                visible
                accordion="my-accordion"
                role="tabpanel"
              >
                <div
                  class="row p-2"
                  v-if="currentOf.statut === CONST_OF.ENCOURS"
                >
                  <div class="col-12 text-lg-right">
                    <b-button
                      variant="success"
                      class="btn-icon mr-4"
                      v-if="item.statut === CONST_ETAPE.ATTENTE"
                      @click="demarrer(item, index)"
                    >
                      <span class="btn-icon-label">
                        <i :class="show.ICON_PLAY"></i>
                      </span>
                      Démarrer
                    </b-button>

                    <b-button
                      variant="success"
                      class="btn-icon mr-4"
                      v-if="item.statut === CONST_ETAPE.ARRETER"
                      @click="redemarrer(item)"
                    >
                      <span class="btn-icon-label">
                        <i class="fas fa-play"></i>
                      </span>
                      Redémarrer
                    </b-button>

                    <b-button
                      variant="success"
                      class="btn-icon mr-4"
                      v-if="item.statut === CONST_ETAPE.ENCOURS"
                      @click="terminer(item, index)"
                    >
                      <span class="btn-icon-label">
                        <i :class="show.ICON_THUMBS_UP"></i>
                      </span>
                      Terminer
                    </b-button>

                    <b-button
                      variant="danger"
                      class="btn-icon mr-4"
                      v-if="item.statut === CONST_ETAPE.ENCOURS"
                      @click="arreter(item)"
                    >
                      <span class="btn-icon-label">
                        <i :class="show.ICON_STOP"></i>
                      </span>
                      Arrêter
                    </b-button>

                    <b-button
                      variant="warning"
                      class="btn-icon"
                      v-if="item.statut !== CONST_ETAPE.ATTENTE"
                      @click="reinitialiser(item)"
                    >
                      <span class="btn-icon-label">
                        <i :class="show.ICON_HOURGLASS"></i>
                      </span>
                      Réinitialiser
                    </b-button>
                  </div>
                </div>
                <div class="row mb-n4 mt-0">
                  <div class="col-12">
                    <div class="card">
                      <table class="table table-sm table-bordered">
                        <thead>
                          <tr>
                            <th scope="col">Libellé</th>
                            <th scope="col">Poste de charge</th>
                            <th scope="col">Nature étape</th>
                            <th scope="col">Checklist</th>
                          </tr>
                        </thead>
                        <tbody>
                          <tr>
                            <td>{{ item.libelle }}</td>
                            <td>{{ item.poste_charge.nom }}</td>
                            <td>
                              <b-badge variant="primary" v-if="item.debut"
                                >Début</b-badge
                              >
                              <b-badge
                                variant="success"
                                class="ml-1"
                                v-if="item.fin"
                                >Fin</b-badge
                              >
                              <b-badge
                                variant="primary"
                                class="ml-1"
                                v-if="!item.debut && !item.fin"
                                >Intermediaire</b-badge
                              >
                            </td>
                            <td>
                              <b-badge
                                variant="primary"
                                v-for="(
                                  checklist, indexC
                                ) in item.selected_checklists"
                                :key="indexC"
                                >{{ checklist.nom }}</b-badge
                              >
                              <b-badge
                                variant="primary"
                                class="ml-1"
                                v-if="item.selected_checklists.length === 0"
                                >Pas de checklists</b-badge
                              >
                            </td>
                          </tr>
                        </tbody>
                      </table>
                    </div>
                  </div>
                </div>

                <div class="row mb-n4 mt-n2">
                  <div class="col-md-12 col-lg-6">
                    <b-card no-body class="text-black" header-class="bg-silver">
                      <template v-slot:header>
                        <div class="row">
                          <div class="col-md-12 text-lg-left text-center">
                            <span class="font-weight-bold"
                              >Consommation des matières premières</span
                            >
                          </div>
                        </div>
                      </template>
                      <div class="row">
                        <div class="col-12">
                          <table class="table table-sm">
                            <thead>
                              <tr>
                                <th scope="col">#</th>
                                <th scope="col">Désignation</th>
                                <th scope="col">Référence</th>
                                <th scope="col">Quantité</th>
                                <th scope="col">Stock</th>
                              </tr>
                            </thead>
                            <tbody>
                              <tr
                                v-for="(article, index3) in item.matieres"
                                :key="index3"
                              >
                                <th scope="row">{{ index3 + 1 }}</th>
                                <td>
                                  {{ article.designation }}
                                </td>
                                <td>{{ article.reference }}</td>
                                <td>
                                  {{
                                    (currentOf.quantite *
                                      article.quantite_ref_base) /
                                      currentOf.quantite_reference +
                                    ' ' +
                                    article.unite
                                  }}
                                </td>
                                <td
                                  :class="{
                                    'text-danger':
                                      article.stock <
                                      (currentOf.quantite *
                                        article.quantite_ref_base) /
                                        currentOf.quantite_reference,
                                  }"
                                >
                                  {{ article.stock + ' ' + article.unite }}
                                </td>
                              </tr>

                              <tr v-if="item.matieres.length === 0">
                                <td class="text-center" colspan="5">
                                  Aucune donnée
                                </td>
                              </tr>
                            </tbody>
                          </table>
                        </div>
                      </div>
                    </b-card>
                  </div>
                  <div class="col-md-12 col-lg-6">
                    <b-card no-body class="text-black" header-class="bg-silver">
                      <template v-slot:header>
                        <div
                          class="row"
                          v-if="
                            lastItem &&
                            lastItem.identifiant === item.identifiant
                          "
                        >
                          <div class="col-md-12 text-md-left text-center">
                            <span class="font-weight-bold"
                              >Produit fini à fabriquer
                            </span>
                          </div>
                        </div>
                        <div class="row" v-else>
                          <div class="col-md-12 text-lg-left text-center">
                            <span class="font-weight-bold"
                              >Produits semi-finis à fabriquer
                            </span>
                          </div>
                        </div>
                      </template>
                      <div class="row">
                        <div class="col-12">
                          <table class="table table-sm">
                            <thead>
                              <tr>
                                <th scope="col">#</th>
                                <th scope="col">Désignation</th>
                                <th scope="col">Référence</th>
                                <th scope="col">Quantité</th>
                                <th scope="col">Stock</th>
                              </tr>
                            </thead>
                            <tbody
                              v-if="
                                lastItem &&
                                lastItem.identifiant === item.identifiant
                              "
                            >
                              <tr>
                                <th scope="row">1</th>
                                <td>
                                  {{ currentOf.produit.designation }}
                                </td>
                                <td>{{ currentOf.produit.reference }}</td>
                                <td>
                                  {{
                                    currentOf.quantite +
                                    ' ' +
                                    currentOf.produit.unite
                                  }}
                                </td>
                                <td>
                                  {{
                                    currentOf.produit.stock +
                                    ' ' +
                                    currentOf.produit.unite
                                  }}
                                </td>
                              </tr>
                            </tbody>
                            <tbody v-else>
                              <template
                                v-for="(article, index3) in item.produits"
                              >
                                <tr :key="index3">
                                  <th scope="row">{{ index3 + 1 }}</th>
                                  <td>
                                    {{ article.designation }}
                                  </td>
                                  <td>{{ article.reference }}</td>
                                  <td>
                                    {{
                                      (currentOf.quantite *
                                        article.quantite_ref_base) /
                                        currentOf.quantite_reference +
                                      ' ' +
                                      article.unite
                                    }}
                                  </td>
                                  <td>
                                    {{ article.stock + ' ' + article.unite }}
                                  </td>
                                </tr>
                              </template>

                              <tr v-if="item.produits.length === 0">
                                <td class="text-center" colspan="5">
                                  Aucune donnée
                                </td>
                              </tr>
                            </tbody>
                          </table>
                        </div>
                      </div>
                    </b-card>
                  </div>
                </div>
              </b-collapse>
            </b-card>
          </div>
        </div>
      </div>

      <div class="row mt-n4" v-if="statutMatieres.length > 0">
        <div class="col-lg-12">
          <div role="tablist">
            <b-card no-body class="mb-2">
              <b-card-header
                header-tag="header"
                role="tab"
                v-b-toggle="'accordion-resume'"
                header-class="bg-silver"
              >
                <span class="when-open">
                  <h6 class="m-0">
                    <a class="text-dark" href="javascript: void(0);"
                      >Resumé de l'OF</a
                    >
                    <span class="accicon">
                      <i :class="show.ICON_ANGLE_UP"></i>
                    </span>
                  </h6>
                </span>
                <span class="when-closed">
                  <h6 class="m-0">
                    <a class="text-dark" href="javascript: void(0);"
                      >Resumé de l'OF</a
                    >
                    <span class="accicon">
                      <i :class="show.ICON_ANGLE_DOWN"></i>
                    </span>
                  </h6>
                </span>
              </b-card-header>
              <b-collapse
                style="background-color: #f3f3f3"
                id="accordion-resume"
                visible
                accordion="my-accordion"
                role="tabpanel"
              >
                <div class="row p-2">
                  <div class="col-12">
                    <p>Resumé des matières premières de l'OF</p>
                  </div>
                </div>
                <div class="row mt-n4">
                  <div class="col-12">
                    <div class="card">
                      <table class="table table-sm table-bordered">
                        <thead>
                          <tr>
                            <th scope="col">Etape</th>
                            <th scope="col">Matière prémière</th>
                            <th scope="col">Quantité requise</th>
                            <th scope="col">Stock</th>
                          </tr>
                        </thead>
                        <tbody>
                          <template v-for="(etape, etapeKey) in statutMatieres">
                            <tr
                              v-for="(matiere, Mkey) in etape.matieres"
                              :key="etapeKey + '-' + Mkey"
                            >
                              <td
                                v-if="Mkey === 0"
                                :rowspan="etape.matieres.length"
                                class="vertical-align"
                              >
                                {{ etape.libelle }}
                              </td>
                              <td>{{ matiere.designation }}</td>
                              <td>
                                {{
                                  (currentOf.quantite *
                                    matiere.quantite_ref_base) /
                                    currentOf.quantite_reference +
                                  ' ' +
                                  matiere.unite
                                }}
                              </td>
                              <td
                                :class="{
                                  'text-danger':
                                    matiere.stock <
                                    (currentOf.quantite *
                                      matiere.quantite_ref_base) /
                                      currentOf.quantite_reference,
                                }"
                              >
                                {{ matiere.stock + ' ' + matiere.unite }}
                              </td>
                            </tr>
                          </template>

                          <tr v-if="statutMatieres.length === 0">
                            <td class="text-center" colspan="4">
                              Aucune donnée
                            </td>
                          </tr>
                        </tbody>
                      </table>
                    </div>
                  </div>
                </div>
              </b-collapse>
            </b-card>
          </div>
        </div>
      </div>
    </div>
    <ModalLancement
      ref="modalLancement"
      :currentEtape="currentEtape"
      :currentIndex="currentIndex"
      @onUpdateEtape="updateEtape"
    />
    <ModalCloture
      ref="modalCloture"
      :currentEtape="currentEtape"
      :currentIndex="currentIndex"
      @onUpdateEtape="updateEtape"
    />
  </div>
</template>

<script>
import { show } from '@/icons/gpao/of';
import URL_E from '@/http/gpao/of-etape';
import ModalLancement from './modals/ModalLancement.vue';
import ModalCloture from './modals/ModalCloture.vue';
import { mapGetters } from 'vuex';
import CONST_OF from '@/constants/gpao/of';
import CONST_ETAPE from '@/constants/gpao/etape';

export default {
  data() {
    return {
      show,
      currentEtape: null,
      currentIndex: null,
      CONST_OF,
      CONST_ETAPE,
    };
  },
  components: {
    ModalLancement,
    ModalCloture,
  },
  computed: {
    ...mapGetters('of', ['currentOf']),
    lastItem() {
      return (
        this.currentOf.item_lists.find((item) => item.fin === true) || null
      );
    },
    statutMatieres() {
      let matieres = [];

      this.currentOf.item_lists.map((item) => {
        let currentData = window._.filter(
          item.matieres,
          (matiere) =>
            matiere.stock <
            (this.currentOf.quantite * matiere.quantite_ref_base) /
              this.currentOf.quantite_reference
        );
        if (currentData.length > 0) {
          matieres.push({
            libelle: item.libelle,
            matieres: currentData,
          });
        }
      });

      return matieres;
    },
  },
  methods: {
    updateEtape(etape) {
      this.$set(
        this.currentOf.item_lists,
        this.currentOf.item_lists.findIndex((e) => e.id === etape.id),
        etape
      );
    },
    reinitialiser(currentEtape) {
      this.showConfirmValidation().then((result) => {
        if (result.value) {
          window.axios
            .put(URL_E.REINITIALISER + '/' + currentEtape.id)
            .then((resp) => {
              this.showSimpleAlerte('top-end', 'success', resp.data.message);
              this.updateEtape(resp.data.etape);
            })
            .catch();
        }
      });
    },
    demarrer(currentEtape, currentIndex) {
      this.currentEtape = currentEtape;
      this.currentIndex = currentIndex;
      this.$refs.modalLancement.showModal();
    },
    arreter(currentEtape) {
      this.showConfirmValidation().then((result) => {
        if (result.value) {
          window.axios
            .put(URL_E.ARRETER + '/' + currentEtape.id)
            .then((resp) => {
              this.showSimpleAlerte('top-end', 'success', resp.data.message);
              this.updateEtape(resp.data.etape);
            })
            .catch();
        }
      });
    },
    terminer(currentEtape, currentIndex) {
      this.currentEtape = currentEtape;
      this.currentIndex = currentIndex;
      this.$refs.modalCloture.showModal();
    },
    redemarrer(currentEtape) {
      this.showConfirmValidation().then((result) => {
        if (result.value) {
          window.axios
            .put(URL_E.REDEMARRER + '/' + currentEtape.id)
            .then((resp) => {
              this.showSimpleAlerte('top-end', 'success', resp.data.message);
              this.updateEtape(resp.data.etape);
            })
            .catch();
        }
      });
    },
  },
};
</script>

<style scoped>
.card-header .accicon {
  float: right;
}
.card-header {
  cursor: pointer;
  border-bottom: 5px;
}
.card {
  border: 1px solid #ddd;
}

.bg-silver {
  background-color: transparent;
  border-color: #ced4da;
}

.collapsed > .when-open,
.not-collapsed > .when-closed {
  display: none;
}
</style>
